import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, IconButton, Image, Box, Text } from "@chakra-ui/react";
import { MdMenu, MdClose } from "react-icons/md"; // Hamburger and Close icons
import { useMsal } from "@azure/msal-react"; // Import useMsal for logout functionality
import "./layout.css";

interface NavbarProps {
  toggleSidebar: () => void; // Function to toggle the sidebar
  isSidebarExpanded: boolean; // Sidebar state to determine the icon
}

const Navbar: React.FC<NavbarProps> = ({
  toggleSidebar,
  isSidebarExpanded,
}) => {
  const { instance, accounts } = useMsal(); // MSAL instance and accounts
  const navigate = useNavigate(); // React Router navigation

  const handleLogout = () => {
    instance
      .logoutPopup() // Use logoutPopup for a popup-based logout
      .then(() => {
        console.log("User logged out successfully");
        navigate("/login"); // Redirect to login page after logout
      })
      .catch((error) => {
        console.error("Logout failed: ", error);
      });
  };

  // Get the username from the account object
  const name = accounts && accounts.length > 0 ? accounts[0].name : "";

  return (
    <nav className="navbar">
      {/* Left: Sidebar Toggle and Logo */}
      <div className="navbar-left">
        {/* Logo Section */}
        <Box
          className={`navbar-logo ${
            isSidebarExpanded ? "expanded" : "collapsed"
          }`}
        >
          {isSidebarExpanded ? (
            <Image
              src="/mainLogo2.png"
              alt="Big Logo"
              width="200px"
              height="90px"
            />
          ) : (
            <Image
              src="/smallLogo4.png"
              alt="Small Logo"
              width="100px"
              height="100px"
            />
          )}
        </Box>
        {/* Sidebar Toggle */}
        <IconButton
          icon={isSidebarExpanded ? <MdClose /> : <MdMenu />} // Toggle icons
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
          backgroundColor="#17263a"
          color="#fff"
          _hover={{ backgroundColor: "#17263a" }}
        />
      </div>

      {/* Right: Username and Logout Button */}
      <div className="navbar-right">
        {/* Display the username */}
        <i className="bi bi-person-circle" style={{marginRight:"8px"}}></i>
        <Text marginRight={4} fontWeight="bold">
          {name || "Guest"}
        </Text>
        <Button
          colorScheme="blue"
          onClick={handleLogout} // Call the logout function
          marginRight={50}
        >
          Sign Out
        </Button>
      </div>
    </nav>
  );
};

export default Navbar;
